import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import UserBadge from '../../common/components/UserBadge';
import categorizeUserBadges from '../utils/categorizeUserBadges';
import BadgeModal from './BadgeModal';
export default class UserBadgeList extends Component {
  view() {
    const categories = categorizeUserBadges(this.attrs.user);
    return m("div", {
      className: "UserBadges"
    }, categories.length === 0 && m("div", {
      className: 'Placeholder'
    }, m("p", null, app.translator.trans('v17development-flarum-badges.forum.user_no_badges'))), categories.length >= 1 && categories.map(({
      name,
      category,
      badges
    }) => {
      if (category && !category.isEnabled()) return null;
      return m("div", {
        className: 'UserBadgesCategory'
      }, m("h3", null, name), category && category.description() && m("p", null, category.description()), badges.sort((a, b) => a.badge().order() - b.badge().order()).map(userBadge => m(UserBadge, {
        badge: userBadge.badge(),
        onclick: () => app.modal.show(BadgeModal, {
          badge: userBadge.badge(),
          userBadgeData: userBadge
        })
      })));
    }));
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/UserBadgeList', UserBadgeList);